<template>
  <div :class="[$style.base]">
    <RadioCardOption
      v-for="(option, index) in options"
      :key="`option_${index}`"
      v-model="option.value"
      :image="option.image"
      :label="option.label"
      :selected="modelValue === option.value"
      @update:modelValue="$emit('update:modelValue', option.value)"
      v-test="'radio-card-option'"
    />
  </div>
</template>

<script
  setup
  lang="ts"
>
import RadioCardOption from './RadioCardOption.vue';

defineEmits(['update:modelValue']);

type Option = {
  label: string;
  image: string;
  value: string | boolean;
};

defineProps<{
  modelValue: string | boolean;
  options?: Option[];
}>();
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  flex: 1;
  gap: $spacing;
  height: 100%;
}
</style>
